export const gifs = [
  {
    source: "Conveyor-1200-COMPRESSED.gif",
    width: "auto",
    height: 340,
    coords: { x: 4834, y: 2757 },
  },
  {
    source: "Forklift-warehouse-2-1200-COMPRESSED.gif",
    width: "auto",
    height: 450,
    coords: { x: 3048, y: 1613 },
  },
  {
    source: "Lecturer-2-800-COMPRESSED.gif",
    width: "auto",
    height: 100,
    coords: { x: 4709, y: 2215 },
  },
  {
    source: "Man-gesturing-and-forklift-2-1200-COMPRESSED.gif",
    width: "auto",
    height: 305,
    coords: { x: 4229, y: 3338 },
  },
  {
    source: "Man-walking-2-1200-COMPRESSED-CROPPED.gif",
    width: "auto",
    height: 145,
    coords: { x: 4550, y: 4373 },
  },
  {
    source: "Pancake-flip-2-1200-COMPRESSED-CROPPED.gif",
    width: "auto",
    height: 85,
    coords: { x: 4660, y: 4080 },
  },
  {
    source: "Truck-reversing-2-1000-COMPRESSED-CROPPED.gif",
    width: "auto",
    height: 625,
    coords: { x: 2315, y: 3590 },
  },
];
